import { create } from 'zustand';
import { AderenciaTableData } from './types';
import { CoverageUploadResponseType, UploadState } from '../SetupInfoPanelAnaliseDeCobertura/@types';

type State = {
  uploadState: UploadState;
  aderenciaProductUploadResponse: CoverageUploadResponseType;
  openModalAderenciaProductUpload: boolean;
  aderenciaProductUploadError: boolean;
  aderenciaProdutoTableData: AderenciaTableData[];
  aderenciaProdutoCacheTableData: AderenciaTableData[];
  openModalCoverageAlert: boolean;
  uploadFileErrorMessage: string | null;
};

type Actions = {
  setSetupAnaliseDeAderenciaState: (name: string, data: any) => void;
  setAderenciaData: (data: any) => void;
  setAderenciaProdutoTableData: () => void;
  setAderenciaOpenModalProduto: () => void;
  setAderenciaClickProsseguirProduto: () => void;
  setAderenciaUploadTableData: (resp: any) => void;
  setToUploadInitialList: () => void;
  reset: () => void;
};

const initialState: State = {
  uploadState: UploadState.IDLE,
  aderenciaProductUploadResponse: {} as CoverageUploadResponseType,
  openModalAderenciaProductUpload: false,
  aderenciaProductUploadError: false,
  aderenciaProdutoTableData: [],
  aderenciaProdutoCacheTableData: [],
  openModalCoverageAlert: false,
  uploadFileErrorMessage: null,
};

export const useSetupAderenciaDePrecosStore = create<State & Actions>(set => ({
  ...initialState,
  setSetupAnaliseDeAderenciaState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  setAderenciaData: (resp: any) => {
    const data = resp.data;

    set(() => ({
      aderenciaProdutoTableData: data?.content || [],
      aderenciaProdutoCacheTableData: data?.content || [],
      aderenciaProductUploadResponse: {
        uploadId: data ? data?.uploadId : '',
        invalidos: data ? data?.invalidos : 0,
        nomeArquivo: data ? data?.nomeArquivoGtins : '',
        usuario: data ? data?.usuarioEnvioGtins : '',
        dataEnvio: data ? data?.dataEnvioGtins : '',
      },
    }));
  },
  setAderenciaProdutoTableData: () => {
    const uploadData = obj => ({
      ...obj.aderenciaProductUploadResponse,
      dataEnvio: obj.aderenciaProductUploadResponse?.dataEnvio,
      usuario: obj.aderenciaProductUploadResponse?.usuario,
      nomeArquivo: obj.aderenciaProductUploadResponse?.nomeArquivo,
      uploadId: obj.aderenciaProductUploadResponse?.uploadId,
      invalidos: obj.aderenciaProductUploadResponse?.invalidos,
    });
    set(state => ({
      aderenciaProductUploadResponse: uploadData(state),
    }));
  },
  setAderenciaOpenModalProduto: () => {
    set(() => ({
      openModalAderenciaProductUpload: true,
      aderenciaProductUploadError: false,
      uploadState: UploadState.IDLE,
    }));
  },
  setAderenciaClickProsseguirProduto: () => {
    set(state => ({
      openModalAderenciaProductUpload: false,
      aderenciaProdutoTableData: {
        dataEnvio: state.aderenciaProductUploadResponse.dataEnvioGtins,
        usuario: state.aderenciaProductUploadResponse.usuarioEnvioGtins,
        nomeArquivo: state.aderenciaProductUploadResponse.nomeArquivoGtins,
        uploadId: state.aderenciaProductUploadResponse.uploadId,
        invalidos: state.aderenciaProductUploadResponse.invalidos,
      },
    }));
  },
  setAderenciaUploadTableData: (resp: any) => {
    function tableList(resp: any, state: State) {
      const data = resp.data;
      const formatList = state.aderenciaProdutoTableData.map(item => {
        return {
          ...item,
          atual: false,
        };
      });

      const newItem = {
        pendente: true,
        atual: false,
        uploadId: data.uploadId,
        nomeArquivo: data.nomeArquivo,
        usuario: data.usuario,
        dataEnvio: data.dataEnvio,
      };

      return [newItem, ...formatList];
    }

    set(state => ({
      aderenciaProdutoTableData: tableList(resp, state),
    }));
  },
  setToUploadInitialList: () => {
    set(state => ({
      aderenciaProdutoTableData: state.aderenciaProdutoCacheTableData,
    }));
  },
  reset: () => {
    set(initialState);
  },
}));
